<template>
    <label class="container body-2 ml-0 pl-1">
        <input
            v-bind="$attrs"
            class="input"
            type="checkbox"
            :checked="checked"
            :name="name"
            :data-meta-id="dataMetaId"
            :id="id"
            @change="emitValue($event.target.checked)"
        />
        <span class="switch" />
        <span class="v-label label theme--light ml-2" :aria-label="ariaLabel">
            {{ label }}
        </span>
    </label>
</template>

<script>
/*
    I used this tutorial to make the component : "How to Build an Accessible Toggle Switch with Vue 3"
    https://dev.to/thomaslombart/how-to-build-a-reusable-and-accessible-toggle-switch-with-vue-3hh7
*/
export default {
    name: 'switch',
    props: {
        label: { type: String, required: true },
        ariaLabel: { type: String, required: true },
        checked: { type: Boolean, required: true },
        name: { type: String, required: true },
        dataMetaId: { type: String, required: true },
        id: { type: String, required: true },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:checked', value ? 1 : 0);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

.container {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.label {
    margin-left: 12px;
    /* Show an ellipsis if the text takes more than one line */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Visually hide the checkbox input */
.input {
    position: absolute;
    width: 0px;
    height: 0px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.switch {
    --switch-container-width: 50px;
    --switch-size: calc(var(--switch-container-width) / 2);
    --light-gray: rgb(184, 184, 184);
    --gray: #cbd5e0;
    --dark-gray: #a0aec0;
    --dark-gray-focus: #707071;
    /* Vertically center the inner circle */
    display: flex;
    align-items: center;
    position: relative;
    height: var(--switch-size);
    flex-basis: var(--switch-container-width);
    /* Make the container element rounded */
    border-radius: var(--switch-size);
    background-color: var(--light-gray);
    /* In case the label gets really long, the toggle shouldn't shrink. */
    flex-shrink: 0;
    transition: background-color 0.25s ease-in-out;
}
.switch::before {
    content: "";
    position: absolute;
    /* Move a little bit the inner circle to the right */
    left: 1px;
    height: calc(var(--switch-size) - 4px);
    width: calc(var(--switch-size) - 4px);
    /* Make the inner circle fully rounded */
    border-radius: 9999px;
    background-color: white;
    border: 2px solid var(--light-gray);
    transition: transform 0.375s ease-in-out;
}
.input:checked + .switch {
    background-color: $primary-base;
}
.input:checked + .switch::before {
    border-color: $primary-base;
    /* Move the inner circle to the right */
    transform: translateX(
        calc(var(--switch-container-width) - var(--switch-size))
    );
}
.input:focus + .switch::before,
.input:hover + .switch::before{
    border-color: var(--dark-gray-focus);
    box-shadow: 0px 0px 6px 6px var(--dark-gray-focus);
}
.input:focus:checked + .switch::before,
.input:hover:checked + .switch::before{
    border-color: $primary-base;
    box-shadow: 0px 0px 6px 6px $primary-base;
}
.input:disabled + .switch {
    background-color: var(--gray);
}
.input:disabled + .switch::before {
    background-color: var(--dark-gray);
    border-color: var(--dark-gray);
}
</style>
